<h1 class="h1">{{translations.pageTitle}}</h1>
<vue-server-messages [messages]="messages"></vue-server-messages>
<form #howForm="ngForm" class="app-form" novalidate>

  @if (hasResetOptions) {
    <vue-panel [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" class="app-container">
      <!-- Form with radio button to select which set of fields to show -->
      {{ 'RetrieveUserComponent.MandatoryFields' | translate: ACCOUNT_RECOVERY_BUNDLE_NAME | async }}
      <vue-control-group [control]="resetChoiceRadio" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" [formError]="formError" labelKey="PasswordResetOptionsComponent.HowDoYouReset">
        <mat-radio-group #inputElement #resetChoiceRadio="ngModel" class="cust-mat-radio-group" id="resetChoiceRadio" name="resetChoice" [(ngModel)]="resetChoice" required (change)="resetForm()">
          @if (pwResetOptions.email) {
            <mat-radio-button id="byEmail" [value]="resetOptionTypeEnum.EMAIL">
              {{ translations.byEmail }}
            </mat-radio-button>
          }
          @if (pwResetOptions.sms) {
            <mat-radio-button id="byVerificationCode" [value]="resetOptionTypeEnum.VERIFICATION_CODE">
              {{ translations.bySMS }}
            </mat-radio-button>
          }
          @if (pwResetOptions.questions && pwResetOptions.questions.length > 0) {
            <mat-radio-button id="bySecurityQuestion" [value]="resetOptionTypeEnum.SECURITY_QUESTION">
              {{ translations.bySecurityQuestions }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </vue-control-group>
      @switch (resetChoice) {
        @case (resetOptionTypeEnum.SECURITY_QUESTION) {
          <div id="securityQuestionChoice">
            @for (secQuestion of pwResetOptions.questions; let i = $index; track secQuestion) {
              <vue-control-group [control]="inputControl" excludeValidationMessage='true' widthClass="shorter" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" [label]="secQuestion.name">
                <input #inputElement name="question-{{secQuestion.id}}" id="questionField{{secQuestion.id}}" class="form-control" vueMaxLength="50"
                  [(ngModel)]="securityQuestionsPostBody.securityQuestionAnswers[i].answer" vueRequired #inputControl="ngModel" autocomplete="off">
                  <vue-validation-message [control]="inputControl" [formError]="formError"
                    [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME"
                    vueValidateLength='error.MaxLength'>
                  </vue-validation-message>
                </vue-control-group>
              }
            </div>
          }
        }
        <vue-form-buttons
          [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME"
          secondaryLabelKey="button.Previous"
          (secondaryButtonClicked)="previous()"
          primaryLabelKey="button.Submit"
          (primaryButtonClicked)="submit()">
        </vue-form-buttons>
      </vue-panel>
    }
  </form>
  <app-webng-redirect-form [submitEmitter]="redirectToWebNGFormEventEmitter"></app-webng-redirect-form>
